export enum NavbarItemType {
  BUTTON,
  TEXT,
}
